import Delivery from './delivery';
import DeliveryTab from './DeliveryTab';
import GeneralTab from './GeneralTab';
import PickupTab from './PickupTab';
import RoomServiceTab from './RoomServiceTab';
import WoltDriveOnboardingCard from './WoltDriveOnboardingCard';

export default {
  Delivery,
  DeliveryTab,
  GeneralTab,
  PickupTab,
  RoomServiceTab,
  WoltDriveOnboardingCard,
};
